import { defineTapPropertyExtension, Tap } from '@iotize/tap';
import { DataLogger } from '@iotize/tap/data-log';

declare module '@iotize/tap/lib/tap' {
  interface Tap {
    dataLog: DataLogger;
  }
}

export const _TAP_EXTENSION_DATA_LOG_ = defineTapPropertyExtension(
  'dataLog',
  (context) => {
    return createDataLoggerFromTap(context.tap);
  },
);

export function createDataLoggerFromTap(tap: Tap): DataLogger {
  return new DataLogger(tap);
}
